import { Link } from "react-router-dom";
import SectionHeader from "@/components/feature/SectionHeader";
import ComicCard from "@/components/feature/ComicCard";
import { hotComics, featuredComics } from "@/mocks/comics";

const rankColors = ["text-accent-500", "text-foreground-700", "text-foreground-500"];

export default function HotAndFeatured() {
  const top = hotComics.slice(0, 6);
  return (
    <section id="ranking" className="border-y border-background-200 bg-background-100 py-14 md:py-20">
      <div className="container-site">
        <SectionHeader
          eyebrow="热度榜单"
          title="高人气妖精漫画排行榜"
          subtitle="依据读者热度与追更情况汇总的热门作品，看看大家都在追哪一部。"
        />

        <div className="grid gap-8 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="card overflow-hidden">
              <div className="flex items-center gap-2 border-b border-background-200 bg-background-50 px-5 py-4">
                <i className="ri-fire-fill text-accent-500" />
                <h3 className="font-heading text-base font-semibold text-foreground-900">本周热度 TOP 6</h3>
              </div>
              <ul className="divide-y divide-background-100">
                {top.map((c, i) => (
                  <li key={c.id}>
                    <Link to={`/comic/${c.id}`} className="group flex items-center gap-3 px-5 py-3.5 transition-colors hover:bg-background-100">
                      <span className={`w-6 shrink-0 text-center font-heading text-xl font-bold ${rankColors[i] ?? "text-foreground-400"}`}>{i + 1}</span>
                      <img src={c.cover} alt={`${c.title} 漫画封面`} loading="lazy" className="h-14 w-10 rounded object-cover object-top" />
                      <div className="min-w-0 flex-1">
                        <p className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700">{c.title}</p>
                        <p className="mt-0.5 flex items-center gap-2 text-xs text-foreground-500">
                          <span>{c.status}</span>
                          <span className="flex items-center gap-0.5"><i className="ri-eye-line" />{c.views}</span>
                        </p>
                      </div>
                      <span className="flex shrink-0 items-center gap-1 text-sm font-semibold text-accent-600">
                        <i className="ri-star-fill text-accent-500" />
                        {c.rating.toFixed(1)}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="mb-5 flex items-center justify-between">
              <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-900">
                <i className="ri-sparkling-2-fill text-accent-500" />
                编辑精选推荐
              </h3>
              <Link to="/category/otherworld" className="text-xs font-medium text-primary-700 hover:text-primary-800">
                查看全部作品 <i className="ri-arrow-right-line" />
              </Link>
            </div>
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-2">
              {featuredComics.map((c) => (
                <ComicCard key={c.id} comic={c} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}